import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';
import { NtRegionalAccessMonitoringInterface } from '../../../../../../shared/interfaces/nt-regional-access-monitoring.interface';

@Component({
  selector: 'app-monitoring-complete-access',
  imports: [CommonModule],
  templateUrl: './monitoring-complete-access.component.html',
  styleUrl: './monitoring-complete-access.component.css',
})
export class MonitoringCompleteAccessComponent implements OnInit {
  isLoading: boolean = true;

  public medicineId: number = 0;
  public companyId: number = 0;
  public countryId: number = 1;
  hasData: boolean = false;

  rows: NtRegionalAccessMonitoringInterface[] = [];

  constructor(
    private us: DmtUtilityService,
    private dataService: DataService,
  ) {}

  ngOnInit(): void {
    this.getSessionVariables();

    this.dataService
      .getForecastVsActualCompleteAccess(
        this.companyId,
        this.medicineId,
        this.countryId,
      )
      .subscribe((data) => {
      // If no data, create placeholder
      // we can simulate empty data with data=[]
      //data=[]
        if (!data || data.length === 0) {
          this.rows = this.createPlaceholderData();
          this.hasData = false;
        } else {
          this.rows = data;
          this.rows.sort((a, b) => a.regionName.localeCompare(b.regionName));
          this.hasData = true;
        }
        
        this.isLoading = false;
      });
  }

  getStatusDelta(delta: number) {
    let bgClass;

    if (delta === 0) {
      bgClass = 'bg-white';
    } else if (delta > 0) {
      bgClass = 'bg-red-100';
    } else if (delta < 0) {
      bgClass = 'bg-green-100';
    }
    return bgClass;
  }

/**
 * Create placeholder data with Italian regions
 */
private createPlaceholderData(): NtRegionalAccessMonitoringInterface[] {
  const regions = [
    'ABRUZZO',
    'BASILICATA',
    'CALABRIA',
    'CAMPANIA',
  ];

  return regions.map((region, index) => ({
    regionId: index + 1,
    regionName: region,
    forecast: null as any,
    actual: null as any,
    delta: null as any
  }));
}

  getSessionVariables() {
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId');
    this.companyId = this.us.getSessionVariableNumber('companyId', 0);
  }
}
